import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import TasksView from "../projects/TasksView";
import { FETCH_ALL_PROJECT_TASKS } from "./graphql";

const ProjectTasks = () => {
  const { loading, error, data } = useQuery(FETCH_ALL_PROJECT_TASKS, {
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <Page title="Project Tasks Overview" backTo="./..">
      <div className="p-6 grid lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
        {data.projects.results.map((project) => (
          <TasksView
            projectId={project.id}
            title={project.name}
            showProjectLink
          />
        ))}
      </div>
    </Page>
  );
};

export default ProjectTasks;
